import AOS from 'aos';

let isInitialized = false;

export const initializeAOS = (options = {}) => {
  try {
    // Check if AOS is available
    if (typeof AOS === 'undefined' || !AOS) {
      console.warn('AOS is not available. Make sure it is properly imported.');
      return;
    }

    if (isInitialized) {
      // If already initialized, just refresh
      AOS.refresh();
      return;
    }

    const defaultOptions = {
      duration: 800,
      once: true,
      offset: 0, // Changed to 0 so elements in viewport trigger immediately
      easing: "ease-in-out",
      startEvent: 'DOMContentLoaded' // Start earlier instead of waiting for 'load' event
    };

    AOS.init({ ...defaultOptions, ...options });
    isInitialized = true;
  } catch (error) {
    console.error('Error initializing AOS:', error);
  }
};

export const refreshAOS = () => {
  try {
    // Check if AOS is available
    if (typeof AOS === 'undefined' || !AOS) {
      console.warn('AOS is not available. Make sure it is properly imported.');
      return;
    }

    if (isInitialized) {
      AOS.refresh();
    } else {
      // Initialize AOS if not already initialized
      initializeAOS();
    }
  } catch (error) {
    console.error('Error refreshing AOS:', error);
  }
};

export const destroyAOS = () => {
  try {
    // Check if AOS is available
    if (typeof AOS === 'undefined' || !AOS) {
      console.warn('AOS is not available. Make sure it is properly imported.');
      return;
    }

    if (isInitialized) {
      AOS.destroy();
      isInitialized = false;
    }
  } catch (error) {
    console.error('Error destroying AOS:', error);
  }
};
